import { Field } from 'redux-form'
import Label from './Label'
import { AddRequiredValidation } from '..'

const renderTextareaField = ({
  input,
  isRequired,
  autocomplete = 'on',
  minlength,
  maxlength,
  rows,
  cols,
  placeholder,
  disabled,
  readOnly,
  spellcheck = 'default',
  wrap = 'soft',
  label,
  ariaLabel,
  meta,
  meta: {
    touched,
    error,
    warning,
    active,
    submitFailed,
  },
  loadingError
}) => {
  const errored = ((touched || submitFailed || (input.value && !touched && !active)) && Boolean(error)) || Boolean(loadingError)
  const errorId = `errMessage-${input.name}`

  return (
    <div className={`form-group ${errored ? 'has-error' : ''}`}>
      {label ? <Label name={input.name} isRequired={isRequired} label={label} /> : null}
      <div className="cb-input-state">
        <textarea
          {...input}
          id={input.name}
          type={input.type}
          placeholder={placeholder || `Enter ${label.toLowerCase()}`}
          className="form-control"
          minLength={minlength}
          maxLength={maxlength}
          rows={rows}
          cols={cols}
          aria-label={label || ariaLabel}
          aria-required={isRequired}
          aria-invalid={errored}
          aria-describedby={errored ? errorId : null}
          disabled={disabled}
          readOnly={readOnly}
          autoComplete={autocomplete}
          spellCheck={spellcheck}
          wrap={wrap}
          onFocus={e => {
            e.target.select()
            input.onFocus()
          }}
        >
          {input.value}
        </textarea>
        {errored ? <i className="cb-glyph cb-x-mark" aria-hidden={true} /> : null}
      </div>
      {errored ? <p tabIndex="-1" id={errorId} className="cb-error-msg">{loadingError || error}</p> : null}
    </div>
  )
}

// store empty strings as nulls for backend...
export default props => (
  <Field
    {...props}
    component={renderTextareaField}
    validate={AddRequiredValidation(props.isRequired, props.validate)}
    normalize={val => (val === '' ? null : props.normalize ? props.normalize(val) : val)}
  />
)